import { ICandidateLanguage } from 'core/interface/candidate-language';
import { JobCitiesResultsType } from 'core/interface/job';

export interface MathFilterValues {
  industry: string;
  career_level: string[];
  degree_type: string;
  computer_skill: string;
  city: { id: number; name: string };
  salary: string[];
  languages: any;
  contracts: string[];
  is_remote: boolean;
  relocations: string[];
  availabilities: string[];
  management_exps: string[];
  [key: string]:
    | string
    | any
    | string[]
    | any
    | JobCitiesResultsType
    | null
    | boolean;
}

export const initialValues: MathFilterValues = {
  industry: '',
  education: [],
  degree_type: '',
  computer_skill: '',
  city: { id: -1, name: '' },
  salary: [],
  career_level: [],
  languages: [],
  contracts: [],
  is_remote: false,
  relocations: [],
  availabilities: [],
  management_exps: []
};

export interface MatchProfileProps {
  setInitialValue: (values: any) => void;
  initialValue: MathFilterValues;
}
